export const BankAccountIcon = () => (
  <svg
    id="icon-svg-bank-account"
    viewBox="0 0 995.905 663.937"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>bank account</title>
    <path
      d="M1008.456,789.362a66.4,66.4,0,0,1-66.394,66.394H78.945a66.4,66.4,0,0,1-66.394-66.394V258.213a66.4,66.4,0,0,1,66.394-66.394H942.062a66.4,66.4,0,0,1,66.394,66.394Z"
      transform="translate(-12.551 -191.819)"
      className="svg-bank-account-path1"
    ></path>
    <path
      d="M397.315,428.614c-.438-2.766-2.281-4.609-5.031-4.609H338c-2.074,0-3.234,1.242-4.133,2.91C317.626,435.493,102.091,644.886,15.612,734.5l-3.061,8.31v46.557a66.4,66.4,0,0,0,66.394,66.394H472.331c92.5-93.462,176.368-178.924,177.872-182.5a4.1,4.1,0,0,0,2.8-3.912L547.078,665.53c39.735-40.569,66.56-68.4,67.4-70.411a4.1,4.1,0,0,0,2.8-3.912l-36.944-46.431c47.709-48.595,81.2-83.193,82.141-85.439a4.1,4.1,0,0,0,2.8-3.912L504.02,449.616Z"
      transform="translate(-12.551 -191.819)"
      className="svg-bank-account-path2"
    ></path>
    <path
      d="M662.708,424.808,498.137,348.263,333.565,424.808v30.618H662.708ZM652.182,616.17H344.089v53.581H652.182ZM563.2,478.389h53.582V593.206H563.2Zm-38.272,0H471.346V593.206h53.581Zm-145.435,0h53.581V593.206H379.492Z"
      transform="translate(-12.551 -191.819)"
      className="svg-bank-account-path3"
    ></path>
  </svg>
)

export const EftIcon = () => (
  <svg
    id="icon-svg-eft"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>eft</title>
    <path
      className="svg-ach-path1"
      d="M1009.95,777.6A66.364,66.364,0,0,1,943.622,844H80.45a66.364,66.364,0,0,1-66.4-66.328V246.4A66.364,66.364,0,0,1,80.378,180H943.55a66.364,66.364,0,0,1,66.4,66.328V777.6Z"
    ></path>
    <path
      className="svg-ach-path2"
      d="M732.957,671.618a5.034,5.034,0,0,0,1.465-3.536s.259-204.453.374-204.613l57.55-57.45a5.034,5.034,0,0,0,1.465-3.535V361.091a5,5,0,0,0-5-5H618.7a5.034,5.034,0,0,0-3.536,1.465l-28.2,28.247V361.091a5,5,0,0,0-5-5h-153a5.034,5.034,0,0,0-3.536,1.465c-.263.4-32.15,32.188-32.228,32.279V361.091a5,5,0,0,0-5-5h-153a5.03,5.03,0,0,0-3.536,1.465L14.06,575.232V777.6A66.364,66.364,0,0,0,80.388,844h480.1Z"
    ></path>
    <path
      className="svg-ach-path3"
      d="M388.192,356.091h-153a5,5,0,0,0-5,5V668.082a5,5,0,0,0,5,5h153a5,5,0,0,0,5-5V624.1a5,5,0,0,0-5-5H291.526V538.989h83.58a5,5,0,0,0,5-5V492.6a5,5,0,0,0-5-5h-83.58V407.483h96.666a5,5,0,0,0,5-5V361.091a5,5,0,0,0-5-5Z"
    ></path>
    <path
      className="svg-ach-path4"
      d="M581.958,356.091h-153a5,5,0,0,0-5,5V668.082a5,5,0,0,0,5,5h51.336a5,5,0,0,0,5-5V542.007h83.58a5,5,0,0,0,5-5V495.616a5,5,0,0,0-5-5h-83.58V407.483H581.96a5,5,0,0,0,5-5V361.091a5,5,0,0,0-5-5Z"
    ></path>
    <path
      className="svg-ach-path5"
      d="M792.346,357.556a5.034,5.034,0,0,0-3.535-1.465H618.7a5,5,0,0,0-5,5v41.393a5,5,0,0,0,5,5h54.388v260.6a5,5,0,0,0,5,5h51.337a5,5,0,0,0,5-5v-260.6h54.389a5,5,0,0,0,5-5V361.091A5.029,5.029,0,0,0,792.346,357.556Z"
    ></path>
  </svg>
)

export const AmexIcon = () => (
  <svg
    id="icon-svg-amex"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>amex</title>
    <path
      className="svg-amex-path1"
      d="M1009.952 789.632c0 36.668-29.726 66.394-66.394 66.394h-863.117c-36.668 0-66.394-29.726-66.394-66.394v-531.149c0-36.668 29.726-66.394 66.394-66.394h863.117c36.668 0 66.394 29.726 66.394 66.394v531.149z"
    ></path>
    <path
      className="svg-amex-path2"
      d="M891.906 637.626c-4.805 0-12.667 0-17.472 0h-39.32c-4.805 0-11.985 0-15.956 0s-8.955-2.568-11.077-5.854c-2.121-3.286-5.978-9.225-8.57-13.27l-2.629-4.072c-2.592-4.046-6.838-4.034-9.435 0.008l-2.747 4.283c-2.598 4.043-6.461 9.886-8.585 13.128s-7.098 5.778-11.053 5.778c-3.955 0-11.122 0-15.927 0h-11.577c-4.805 0-12.668 0-17.472 0h-8.736c-4.805 0-8.795 0-8.866 0s-4.061 0-8.866 0h-31.802c-4.805 0-12.667 0-17.472 0h-70.27c-4.804 0-10.395 0-12.423 0s-7.619 0-12.423 0h-1.361c-4.804 0-10.395 0-12.423 0s-7.619 0-12.423 0h-22.047c-4.805 0-12.667 0-17.472 0h-10.539c-4.805 0-11.118-3.691-11.118-8.495v-8.052c0-4.805 0-11.964 0-15.907s0.428-5.202-0.505-2.647c-0.933 2.555-3.696 4.525-7.596 4.525s-7.321 0-7.602 0-3.704 0-7.609 0c-3.905 0-9.757-1.88-11.55-4.324s-4.45-1.188-4.45 2.646 0 10.903 0 15.707v8.052c0 4.805-1.549 8.495-6.354 8.495h-7.142c-4.805 0-11.757 0-15.449 0s-12.903 0-17.708 0h-17.487c-4.805 0-9.765 0-11.022 0s-6.218 0-11.023 0h-4.163c-4.805 0-12.667 0-17.472 0h-13.863c-4.805 0-12.667 0-17.472 0h-0.322c-4.804 0-10.213-3.431-12.018-7.771s-4.672-11.28-6.369-15.348c-1.697-4.068-7.018-7.457-11.822-7.457h-15.951c-4.804 0-10.124 3.448-11.82 7.516s-4.561 10.886-6.367 15.228c-1.805 4.341-7.213 7.832-12.018 7.832h-0.325c-4.805 0-12.667 0-17.472 0h-34.227c-4.805 0-12.667 0-17.472 0h-22.008c-4.805 0-7.2-3.498-5.322-7.921l8.498-19.956c1.878-4.422 4.943-11.633 6.811-16.060l68.845-163.145c1.868-4.427 4.913-11.668 6.767-16.1l0.012-0.025c0.333-0.796-0.377-1.55 0.163-2.277l-186.913 185.72v192.012c0 36.668 32.108 66.152 68.776 66.152h624.296l218.794-218.792c-0.698 0.234-1.487 0.392-2.434 0.392h-31.574z"
    ></path>
    <path
      className="svg-amex-path3"
      d="M228.115 533.656c-1.78 4.463 0.694 8.114 5.499 8.114h22.51c4.805 0 7.295-3.657 5.534-8.128l-13.46-34.168c-1.761-4.47-4.659-4.477-6.439-0.014l-13.643 34.196z"
    ></path>
    <path
      className="svg-amex-path4"
      d="M909.841 604.678c-2.686-3.984-7.072-10.509-9.746-14.501l-41.616-62.111c-2.674-3.991-2.678-10.526-0.008-14.521l39.025-58.391c2.67-3.995 7.028-10.539 9.685-14.542l17.901-26.972c2.657-4.003 0.9-7.279-3.905-7.279h-31.818c-4.805 0-12.667 0-17.472 0h-38.045c-4.805 0-11.964 0-15.91 0s-8.913 2.889-11.039 6.419c-2.126 3.53-5.947 9.753-8.491 13.829l-0.492 0.788c-2.544 4.076-6.653 4.042-9.13-0.075l-0.352-0.584c-2.477-4.117-6.236-10.386-8.353-13.931s-7.119-6.446-11.115-6.446c-3.997 0-11.198 0-16.003 0h-16.674c-4.805 0-12.667 0-17.472 0h-5.174c-4.805 0-9.537 0-10.517 0s-5.712 0-10.517 0h-28.015c-4.805 0-12.667 0-17.472 0h-73.043c-4.805 0-10.395 0-12.423 0s-7.619 0-12.423 0h-1.361c-4.805 0-10.395 0-12.423 0s-7.619 0-12.423 0h-27.36c-4.805 0-12.029 0-16.053 0s-9.044 2.972-11.156 6.605c-2.111 3.633-5.884 9.962-8.384 14.065l-11.129 18.265c-2.5 4.103-6.583 4.098-9.072-0.011l-11.164-18.429c-2.49-4.11-6.254-10.402-8.365-13.983s-7.132-6.511-11.156-6.511c-4.025 0-11.248 0-16.053 0h-34.735c-4.805 0-12.667 0-17.472 0h-9.993c-4.805 0-8.736 3.931-8.736 8.736v10.239c0 4.805 0 12.667 0 17.472v42.302c0 4.805-1.501 5.103-3.336 0.662l-22.818-55.219c-1.835-4.44-4.717-11.701-6.405-16.133s-6.977-8.059-11.756-8.059c-4.778 0-12.619 0-17.424 0h-30.149c-4.805 0-12.651 0-17.435 0s-10.216 3.627-12.070 8.059l-0.012 0.030c-1.854 4.432-4.9 11.681-6.767 16.108l-68.846 163.16c-1.868 4.427-4.932 11.667-6.81 16.090l-8.499 20.016c-1.878 4.423 0.517 8.041 5.322 8.041h22.008c4.805 0 12.667 0 17.472 0h34.227c4.805 0 12.667 0 17.472 0h0.325c4.805 0 10.213-3.552 12.018-7.893s4.67-11.221 6.367-15.288c1.697-4.067 7.015-7.395 11.82-7.395h15.951c4.805 0 10.125 3.329 11.822 7.397s4.563 10.948 6.369 15.288c1.805 4.341 7.213 7.891 12.018 7.891h0.322c4.805 0 12.667 0 17.472 0h13.863c4.805 0 12.667 0 17.472 0h4.163c4.805 0 9.765 0 11.023 0s6.217 0 11.022 0h17.487c4.805 0 11.757 0 15.449 0s10.644 0 15.449 0h7.142c4.805 0 8.736-3.931 8.736-8.736v-8.052c0-4.805 0-11.873 0-15.707s1.466-4.971 3.259-2.526 6.454 4.445 10.358 4.445c3.905 0 7.329 0 7.609 0s3.701 0 7.601 0c3.901 0 7.855-2.090 8.788-4.645s1.696-1.418 1.696 2.526c0 3.944 0 11.103 0 15.907v8.052c0 4.805 3.931 8.736 8.736 8.736h10.539c4.805 0 12.667 0 17.472 0h24.306c4.805 0 10.395 0 12.423 0s7.619 0 12.423 0h1.361c4.805 0 10.395 0 12.423 0s7.619 0 12.423 0h70.27c4.805 0 12.667 0 17.472 0h31.802c4.805 0 8.794 0 8.866 0s4.061 0 8.866 0h8.736c4.805 0 12.667 0 17.472 0h11.577c4.805 0 11.972 0 15.927 0s8.929-2.652 11.053-5.894 5.987-9.202 8.585-13.244l2.747-4.276c2.597-4.042 6.843-4.040 9.435 0.006l2.628 4.103c2.592 4.046 6.449 10.045 8.57 13.33s7.106 5.975 11.077 5.975c3.971 0 11.151 0 15.956 0h39.32c4.805 0 12.667 0 17.472 0h31.574c4.805 0 6.538-3.259 3.853-7.243l-17.491-25.945zM300.848 611.658c-4.805 0-10.248-3.629-12.095-8.064l-6.019-14.447c-1.847-4.436-7.29-8.065-12.095-8.065h-51.542c-4.805 0-10.247 3.629-12.095 8.065l-6.016 14.447c-1.847 4.436-7.29 8.065-12.095 8.065h-34.227c-4.805 0-7.207-3.621-5.337-8.048l68.84-162.992c1.87-4.427 7.33-8.048 12.135-8.048h30.149c4.805 0 10.27 3.62 12.145 8.044l69.077 163.001c1.875 4.424-0.523 8.043-5.328 8.043h-35.498zM540.59 602.922c0 4.805-3.931 8.736-8.736 8.736h-34.944c-4.805 0-8.736-3.931-8.736-8.736v-84.221c0-4.805-2.061-5.388-4.58-1.297l-34.623 56.238c-2.519 4.091-4.809 7.439-5.090 7.439s-2.68-3.278-5.333-7.284l-37.279-56.296c-2.653-4.006-4.823-3.352-4.823 1.452v83.967c0 4.805-3.931 8.736-8.736 8.736h-30.576c-4.805 0-8.736-3.931-8.736-8.736v-161.616c0-4.805 3.931-8.736 8.736-8.736h35.992c4.805 0 10.798 3.347 13.319 7.437l33.362 54.141c2.52 4.091 6.645 4.091 9.166 0l33.366-54.141c2.521-4.091 8.515-7.437 13.319-7.437h36.195c4.805 0 8.736 3.931 8.736 8.736v161.616zM835.114 611.658c-4.805 0-10.837-3.323-13.404-7.385l-24.79-39.221c-2.567-4.061-6.779-4.069-9.36-0.016l-24.996 39.253c-2.581 4.053-8.623 7.368-13.428 7.368h-37.785c-4.805 0-8.794 0-8.866 0s-4.061 0-8.866 0h-126.82c-4.805 0-8.736-3.931-8.736-8.736v-161.616c0-4.805 3.931-8.736 8.736-8.736h126.672c4.805 0 8.736 3.931 8.736 8.736v26.208c0 4.805-3.931 8.736-8.736 8.736h-78.624c-4.805 0-8.736 3.931-8.736 8.736v8.736c0 4.805 3.931 8.736 8.736 8.736h69.888c4.805 0 8.736 3.931 8.736 8.736v21.84c0 4.805-3.931 8.736-8.736 8.736h-69.888c-4.805 0-8.736 3.931-8.736 8.736v13.104c0 4.805 3.931 8.736 8.736 8.736h78.624c4.805 0 8.736 3.931 8.736 8.736v22.138c0 4.805 2.19 5.471 4.866 1.481l51.329-76.519c2.677-3.99 2.7-10.535 0.052-14.544l-48.737-73.779c-2.648-4.009-0.884-7.289 3.921-7.289h39.321c4.805 0 10.818 3.335 13.362 7.41l22.070 35.35c2.544 4.075 6.745 4.098 9.333 0.051l22.676-35.452c2.589-4.048 8.638-7.36 13.443-7.36h38.045c4.805 0 6.545 3.264 3.867 7.253l-48.837 72.745c-2.678 3.989-2.691 10.526-0.029 14.526l51.442 77.292c2.662 4 0.909 7.272-3.896 7.272h-39.32zM719.678 512.415c0-4.805 2.26-5.519 5.022-1.588l2.705 3.849c2.762 3.932 2.869 10.437 0.238 14.458l-3.181 4.86c-2.631 4.020-4.784 3.378-4.784-1.427v-20.152z"
    ></path>
  </svg>
)

export const CreditCardIcon = () => (
  <svg
    id="icon-svg-credit-card"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>credit-card</title>
    <path
      className="svg-credit-card-path1"
      d="M1009.952 789.632c0 36.668-29.726 66.394-66.394 66.394h-863.117c-36.668 0-66.394-29.726-66.394-66.394v-531.149c0-36.668 29.726-66.394 66.394-66.394h863.117c36.668 0 66.394 29.726 66.394 66.394v531.149z"
    ></path>
    <path
      className="svg-credit-card-path2"
      d="M14.048 257.61h995.904v122.304h-995.904v-122.304z"
    ></path>
    <path
      className="svg-credit-card-path3"
      d="M704.192 528.426c0 4.825-3.911 8.736-8.736 8.736h-624.624c-4.825 0-8.736-3.911-8.736-8.736v-91.728c0-4.825 3.911-8.736 8.736-8.736h624.624c4.825 0 8.736 3.911 8.736 8.736v91.728z"
    ></path>
    <path
      className="svg-credit-card-path4"
      d="M953.168 528.426c0 4.825-3.911 8.736-8.736 8.736h-179.088c-4.825 0-8.736-3.911-8.736-8.736v-91.728c0-4.825 3.911-8.736 8.736-8.736h179.088c4.825 0 8.736 3.911 8.736 8.736v91.728z"
    ></path>
    <path
      className="svg-credit-card-path5"
      d="M953.168 790.506c0 4.825-3.911 8.736-8.736 8.736h-436.8c-4.825 0-8.736-3.911-8.736-8.736v-30.576c0-4.825 3.911-8.736 8.736-8.736h436.8c4.825 0 8.736 3.911 8.736 8.736v30.576z"
    ></path>
  </svg>
)

export const DiscoverIcon = () => (
  <svg
    id="icon-svg-discover"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>discover</title>
    <path
      className="svg-discover-path1"
      d="M1009.952 789.632c0 36.668-29.726 66.394-66.394 66.394h-863.117c-36.668 0-66.394-29.726-66.394-66.394v-531.149c0-36.668 29.725-66.394 66.394-66.394h863.117c36.668 0 66.394 29.726 66.394 66.394v531.149z"
    ></path>
    <path
      className="svg-discover-path2"
      d="M947.735 856.026c36.668 0 62.217-28.016 62.217-64.684v-196.023c0 0-252.729 182.083-723.25 260.707h661.033z"
    ></path>
    <path
      className="svg-discover-path3"
      d="M124.706 390.246h-39.809v139.035h39.599c21.056 0 36.261-4.968 49.608-16.051 15.86-13.125 25.24-32.909 25.24-53.37 0-41.031-30.656-69.615-74.638-69.615zM156.387 494.692c-8.522 7.695-19.59 11.052-37.113 11.052h-7.278v-91.94h7.278c17.523 0 28.156 3.134 37.113 11.245 9.379 8.35 15.021 21.291 15.021 34.61 0 13.348-5.642 26.685-15.021 35.033z"
    ></path>
    <path
      className="svg-discover-path4"
      d="M211.822 390.246h27.12v139.035h-27.12v-139.035z"
    ></path>
    <path
      className="svg-discover-path5"
      d="M305.255 443.599c-16.274-6.022-21.053-9.993-21.053-17.505 0-8.758 8.514-15.412 20.203-15.412 8.125 0 14.804 3.339 21.869 11.26l14.189-18.58c-11.661-10.2-25.612-15.414-40.856-15.414-24.599 0-43.363 17.082-43.363 39.838 0 19.154 8.737 28.961 34.207 38.128 10.617 3.745 16.020 6.24 18.748 7.918 5.419 3.539 8.131 8.548 8.131 14.386 0 11.265-8.957 19.611-21.056 19.611-12.936 0-23.354-6.468-29.599-18.543l-17.52 16.87c12.495 18.341 27.5 26.47 48.137 26.47 28.182 0 47.953-18.738 47.953-45.653 0-22.092-9.141-32.090-39.991-43.373z"
    ></path>
    <path
      className="svg-discover-path6"
      d="M353.801 459.86c0 40.866 32.090 72.555 73.386 72.555 11.674 0 21.673-2.295 34.002-8.102v-31.924c-10.842 10.851-20.444 15.228-32.74 15.228-27.314 0-46.699-19.802-46.699-47.958 0-26.692 19.999-47.751 45.437-47.751 12.936 0 22.727 4.616 34.002 15.645v-31.91c-11.905-6.037-21.693-8.54-33.362-8.54-41.086 0-74.027 32.331-74.027 72.757z"
    ></path>
    <path
      className="svg-discover-path7"
      d="M676.218 483.637l-37.076-93.391h-29.627l59.003 142.603h14.593l60.062-142.603h-29.396z"
    ></path>
    <path
      className="svg-discover-path8"
      d="M755.438 529.281h76.912v-23.537h-49.813v-37.53h47.977v-23.55h-47.977v-30.86h49.813v-23.558h-76.912z"
    ></path>
    <path
      className="svg-discover-path9"
      d="M941.919 431.289c0-26.028-17.929-41.047-49.204-41.047h-40.213v139.035h27.089v-55.853h3.535l37.538 55.853h33.352l-43.77-58.573c20.427-4.154 31.673-18.126 31.673-39.416zM887.512 454.252h-7.921v-42.11h8.351c16.891 0 26.070 7.077 26.070 20.607 0 13.977-9.18 21.502-26.501 21.502z"
    ></path>
    <path
      className="svg-discover-path10"
      d="M617.971 460.243c0 40.849-33.114 73.963-73.963 73.963s-73.963-33.114-73.963-73.963c0-40.849 33.114-73.963 73.963-73.963s73.963 33.114 73.963 73.963z"
    ></path>
  </svg>
)

export const MasterCardIcon = () => (
  <svg
    id="icon-svg-mastercard"
    width="100%"
    height="100%"
    viewBox="0 0 153 108"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>mastercard</title>
    <path
      d="M152 97.2C152 103.165 147.463 108 141.867 108H10.1334C4.53693 108 0 103.165 0 97.2V10.8C0 4.83541 4.53693 0 10.1334 0H141.867C147.463 0 152 4.83541 152 10.8V97.2Z"
      className="svg-mastercard-path1"
    />
    <path
      d="M91.8994 25.6992H60.3994V82.2992H91.8994V25.6992Z"
      className="svg-mastercard-path2"
    />
    <path
      d="M62.3998 53.9995C62.3998 42.9995 67.4998 32.4995 76.0998 25.6995C60.4998 13.3995 37.7998 16.0995 25.4998 31.7995C13.2998 47.3995 15.9998 69.9995 31.6998 82.2995C44.7998 92.5995 63.0998 92.5995 76.1998 82.2995C67.4998 75.4995 62.3998 64.9995 62.3998 53.9995Z"
      className="svg-mastercard-path3"
    />
    <path
      d="M134.4 53.9995C134.4 73.8995 118.3 89.9995 98.4002 89.9995C90.3002 89.9995 82.5002 87.2995 76.2002 82.2995C91.8002 69.9995 94.5002 47.3995 82.2002 31.6995C80.4002 29.4995 78.4002 27.3995 76.2002 25.6995C91.8002 13.3995 114.5 16.0995 126.7 31.7995C131.7 38.0995 134.4 45.8995 134.4 53.9995Z"
      className="svg-mastercard-path4"
    />
  </svg>
)

export const VisaIcon = () => (
  <svg
    id="icon-svg-visa"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>visa</title>
    <path
      className="svg-visa-path1"
      d="M1009.952 789.632c0 36.668-29.726 66.394-66.394 66.394h-863.117c-36.668 0-66.394-29.726-66.394-66.394v-531.149c0-36.668 29.726-66.394 66.394-66.394h863.117c36.668 0 66.394 29.726 66.394 66.394v531.149z"
    ></path>
    <path
      className="svg-visa-path2"
      d="M414.145 629.402l34.658-214.563h55.404l-34.658 214.563h-55.404z"
    ></path>
    <path
      className="svg-visa-path3"
      d="M670.516 420.097c-10.961-4.307-28.182-9.001-49.64-9.001-54.779 0-93.339 29.123-93.656 70.811-0.346 30.845 27.519 48.046 48.521 58.294 21.587 10.507 28.835 17.23 28.756 26.628-0.149 14.368-17.23 20.953-33.163 20.953-22.181 0-33.965-3.238-52.185-11.249l-7.129-3.416-7.744 48.026c12.912 5.981 36.866 11.16 61.721 11.438 58.216 0 96.043-28.767 96.488-73.287 0.198-24.459-14.566-42.996-46.541-58.305-19.359-9.942-31.242-16.538-31.103-26.608 0.010-8.922 10.031-18.468 31.737-18.468 18.121-0.287 31.242 3.892 41.461 8.249l4.971 2.455 7.505-46.521z"
    ></path>
    <path
      className="svg-visa-path4"
      d="M812.634 415.046h-42.817c-13.279 0-23.211 3.802-29.034 17.794l-82.279 196.63h58.196c0 0 9.486-26.45 11.645-32.252 6.348 0 62.89 0.109 70.96 0.109 1.663 7.486 6.743 32.143 6.743 32.143h51.422l-44.838-214.425zM744.288 553.332c4.595-12.338 22.072-59.978 22.072-59.978-0.327 0.564 4.565-12.427 7.357-20.479l3.743 18.508c0 0 10.636 51.215 12.824 61.949-8.625 0-35.183 0-45.996 0z"
    ></path>
    <path
      className="svg-visa-path5"
      d="M367.673 415.017l-54.235 146.277-5.803-29.737c-10.11-34.262-41.559-71.396-76.743-90.002l49.601 187.658 58.642-0.039 87.239-214.157h-58.701z"
    ></path>
    <path
      className="svg-visa-path6"
      d="M263.105 414.868h-89.348l-0.733 4.446c69.524 17.775 115.52 60.672 134.612 112.243l-19.418-98.587c-3.347-13.596-13.081-17.626-25.113-18.101z"
    ></path>
  </svg>
)

export const CheckIcon = () => (
  <svg
    id="icon-svg-check"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>check</title>
    <path
      className="svg-check-path1"
      d="M1009.952 789.632c0 36.672-29.728 66.4-66.4 66.4h-863.104c-36.672 0-66.4-29.728-66.4-66.4v-531.136c0-36.672 29.728-66.4 66.4-66.4h863.104c36.672 0 66.4 29.728 66.4 66.4v531.136z"
    ></path>
    <path
      className="svg-check-path2"
      d="M943.552 248.096c5.728 0 10.4 4.672 10.4 10.4v531.136c0 5.728-4.672 10.4-10.4 10.4h-863.104c-5.728 0-10.4-4.672-10.4-10.4v-531.136c0-5.728 4.672-10.4 10.4-10.4h863.104zM943.552 192.096h-863.104c-36.672 0-66.4 29.728-66.4 66.4v531.136c0 36.672 29.728 66.4 66.4 66.4h863.104c36.672 0 66.4-29.728 66.4-66.4v-531.136c0-36.672-29.728-66.4-66.4-66.4v0z"
    ></path>
    <path
      className="svg-check-path3"
      d="M839.936 387.008h-661.952c-11.040 0-20-8.96-20-20s8.96-20 20-20h661.952c11.040 0 20 8.96 20 20s-8.96 20-20 20z"
    ></path>
    <path
      className="svg-check-path4"
      d="M183.808 855.744h14.976l57.952-27.872 10.048-53.12-53.92 13.28c0 0-26.976 57.952-27.36 60.384-0.416 2.4-1.696 7.328-1.696 7.328z"
    ></path>
    <path
      className="svg-check-path5"
      d="M839.936 688.192h-665.824c-11.040 0-20-8.96-20-20v-203.904c0-11.040 8.96-20 20-20h665.824c11.040 0 20 8.96 20 20v203.904c0 11.040-8.96 20-20 20zM194.112 648.192h625.824v-163.904h-625.824v163.904z"
    ></path>
    <path
      className="svg-check-path6"
      d="M771.712 346.368l-71.616-71.616 38.848-38.848c16.864-16.864 44.224-16.864 61.088 0l10.528 10.528c16.864 16.864 16.864 44.224 0 61.088l-38.848 38.848z"
    ></path>
    <path
      className="svg-check-path7"
      d="M272.48 704.608l-54.784 54.784c-7.744 7.744-13.504 17.248-16.768 27.712l-18.24 58.176c-1.024 3.264-0.448 6.464 1.12 8.992l38.88-38.88c-3.936-6.464-3.168-14.976 2.432-20.544 6.528-6.528 17.152-6.528 23.68 0s6.528 17.152 0 23.68c-5.568 5.568-14.112 6.368-20.544 2.432l-38.24 38.24c1.92 0.608 4.064 0.704 6.24 0.064l59.168-16.704c11.168-3.168 21.344-9.12 29.568-17.344l54.048-54.048-66.56-66.56z"
    ></path>
    <path
      className="svg-check-path8"
      d="M280.576 780.416l-14.528-14.528c-23.264-23.264-23.264-60.96 0-84.192l419.584-419.584c23.264-23.264 60.96-23.264 84.192 0l14.528 14.528c23.264 23.264 23.264 60.96 0 84.192l-419.584 419.584c-23.232 23.264-60.928 23.264-84.192 0z"
    ></path>
    <path
      className="svg-check-path9"
      d="M483.463 464.285l98.722 98.722-29.891 29.891-98.722-98.722 29.891-29.891z"
    ></path>
    <path
      className="svg-check-path10"
      d="M587.328 463.232l-4.096-4.096c-6.528-6.528-6.528-17.12 0-23.648l123.584-123.584c6.528-6.528 17.12-6.528 23.648 0l4.096 4.096c6.528 6.528 6.528 17.12 0 23.648l-123.584 123.584c-6.528 6.528-17.12 6.528-23.648 0z"
    ></path>
  </svg>
)

export const CashIcon = () => (
  <svg
    id="icon-svg-cash"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>cash</title>
    <path
      className="svg-cash-path1"
      d="M1009.952 789.632c0 36.672-29.728 66.4-66.4 66.4h-863.104c-36.672 0-66.4-29.728-66.4-66.4v-531.136c0-36.672 29.728-66.4 66.4-66.4h863.104c36.672 0 66.4 29.728 66.4 66.4v531.136z"
    ></path>
    <path
      className="svg-cash-path2"
      d="M943.552 192.096h-863.104c-36.672 0-66.4 29.728-66.4 66.4v531.136c0 36.672 29.728 66.4 66.4 66.4h863.104c36.672 0 66.4-29.728 66.4-66.4v-531.136c0-36.672-29.728-66.4-66.4-66.4v0z"
    ></path>
    <path
      className="svg-cash-path3"
      d="M228.896 276.896c0 77.824-63.072 140.896-140.896 140.896-3.392 0-6.624-0.48-9.952-0.736v205.92c3.328-0.256 6.56-0.736 9.952-0.736 77.824 0 140.896 63.072 140.896 140.896 0 9.984-1.28 19.584-3.296 28.928h572.864c-2.016-9.344-3.296-18.944-3.296-28.928 0-77.824 63.072-140.896 140.896-140.896 3.392 0 6.624 0.48 9.952 0.736v-205.92c-3.328 0.256-6.56 0.736-9.952 0.736-77.824 0-140.896-63.072-140.896-140.896 0-7.104 0.736-14.016 1.792-20.8h-569.856c1.056 6.784 1.792 13.696 1.792 20.8zM502.208 310.080c89.344 0 161.792 96.032 161.792 214.528 0 118.464-72.416 214.528-161.792 214.528s-161.792-96.032-161.792-214.528c0.032-118.464 72.448-214.528 161.792-214.528z"
    ></path>
  </svg>
)

export const BankIcon = () => (
  <svg
    id="icon-svg-bank"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>bank</title>
    <rect
      className="svg-bank-path1"
      x="4.019"
      y="5.954"
      width="1.267"
      height="4.933"
    />
    <rect
      className="svg-bank-path2"
      x="2.186"
      y="5.954"
      width="1.266"
      height="4.933"
    />
    <path
      className="svg-bank-path3"
      d="M9.979,8.42A1.979,1.979,0,1,0,8,10.4,1.981,1.981,0,0,0,9.979,8.42Zm-2.649,0A.67.67,0,1,1,8,9.09.671.671,0,0,1,7.33,8.42Z"
    />
    <path
      className="svg-bank-path4"
      d="M15.783,5.063,8.075.35a.173.173,0,0,0-.183,0L.216,5.063a.175.175,0,0,0,.092.324H15.692a.175.175,0,0,0,.091-.324ZM3.951,4.121,7.984,1.844l4.033,2.277Z"
    />
    <rect
      className="svg-bank-path5"
      x="1.728"
      y="11.454"
      width="12.545"
      height="1.266"
    />
    <rect
      className="svg-bank-path6"
      x="10.715"
      y="5.954"
      width="1.267"
      height="4.933"
    />
    <rect
      className="svg-bank-path7"
      x="12.549"
      y="5.954"
      width="1.266"
      height="4.933"
    />
    <rect
      className="svg-bank-path8"
      x="0.493"
      y="13.287"
      width="15.016"
      height="1.266"
    />
  </svg>
)

export const NewCreditCardIcon = () => (
  <svg
    id="icon-svg-new-credit-card"
    viewBox=" 0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>credit card</title>
    <rect
      className="svg-new-credit-card-path1"
      x="305.062"
      y="665.662"
      width="230.528"
      height="65.456"
    />
    <rect
      className="svg-new-credit-card-path2"
      x="135.619"
      y="665.662"
      width="129.673"
      height="65.456"
    />
    <path
      className="svg-new-credit-card-path3"
      d="M979.3,174.477H44.715c-14.876,0-27.393,7.7-33.871,18.625-2.913,4.526-4.833,9.346-4.833,14.739V814.7a29.331,29.331,0,0,0,2.832,12.419c.123.284.073.63.208.912.043.082.132.144.17.222,5.946,12.2,19.575,20.761,35.494,20.761H979.3c21.374,0,38.7-15.381,38.7-34.355V208.829C1018,189.858,1000.67,174.477,979.3,174.477ZM963,368.859H61.008V231.385H963ZM61.008,792.1V458.843H963V792.1Z"
    />
  </svg>
)

export const ApplyPayIcon = () => (
  <svg
    id="icon-svg-apple-pay"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
  >
    <title>apple-pay</title>
    <path
      className="svg-apple-pay-path1"
      d="M15.875,4.207c0-.045,0-.09,0-.136a1.974,1.974,0,0,0-.027-.3.966.966,0,0,0-.092-.281.939.939,0,0,0-.174-.24.975.975,0,0,0-.24-.174,1,1,0,0,0-.282-.093,1.95,1.95,0,0,0-.3-.026l-.136,0H1.374l-.136,0a1.95,1.95,0,0,0-.3.026A.994.994,0,0,0,.66,3.08a.975.975,0,0,0-.24.174.939.939,0,0,0-.174.24,1,1,0,0,0-.093.281,2.113,2.113,0,0,0-.026.3c0,.046,0,.091,0,.136v7.586c0,.045,0,.09,0,.136a2.113,2.113,0,0,0,.026.3,1,1,0,0,0,.093.281.939.939,0,0,0,.174.24.975.975,0,0,0,.24.174.994.994,0,0,0,.282.093,1.829,1.829,0,0,0,.3.026l.136,0H14.626l.136,0a1.829,1.829,0,0,0,.3-.026,1,1,0,0,0,.282-.093.975.975,0,0,0,.24-.174.939.939,0,0,0,.174-.24.966.966,0,0,0,.092-.281,1.974,1.974,0,0,0,.027-.3c0-.046,0-.091,0-.136V4.207Zm-.336,7.424v.16c0,.043,0,.086,0,.129a1.79,1.79,0,0,1-.021.246.649.649,0,0,1-.062.188.615.615,0,0,1-.267.267.639.639,0,0,1-.188.061,1.7,1.7,0,0,1-.244.021l-.132,0H1.375l-.128,0A1.7,1.7,0,0,1,1,12.682a.655.655,0,0,1-.189-.061.62.62,0,0,1-.266-.267.636.636,0,0,1-.062-.189,1.633,1.633,0,0,1-.021-.245c0-.043,0-.086,0-.129V4.21c0-.043,0-.086,0-.129a1.659,1.659,0,0,1,.021-.247.64.64,0,0,1,.062-.188.585.585,0,0,1,.112-.154.577.577,0,0,1,.155-.113A.669.669,0,0,1,1,3.318,1.635,1.635,0,0,1,1.247,3.3l.129,0H14.624l.129,0A1.646,1.646,0,0,1,15,3.318a.687.687,0,0,1,.189.061.646.646,0,0,1,.154.112.632.632,0,0,1,.112.155.646.646,0,0,1,.062.189,1.764,1.764,0,0,1,.021.246c0,.042,0,.085,0,.129v7.421Z"
    />
    <path
      className="svg-apple-pay-path2"
      d="M4.265,6.362a.867.867,0,0,0,.2-.62.861.861,0,0,0-.572.3.813.813,0,0,0-.2.6A.721.721,0,0,0,4.265,6.362Z"
    />
    <path
      className="svg-apple-pay-path3"
      d="M4.753,7.8a.883.883,0,0,1,.418-.738.913.913,0,0,0-.708-.385c-.319-.019-.59.181-.742.181s-.385-.171-.637-.167a.939.939,0,0,0-.8.485,2,2,0,0,0,.243,1.946c.161.238.356.5.613.491.242-.01.337-.158.632-.158s.381.158.637.153.433-.238.595-.476a2.141,2.141,0,0,0,.266-.547A.865.865,0,0,1,4.753,7.8Z"
    />
    <path
      className="svg-apple-pay-path4"
      d="M7.64,6.014H6.3V9.583h.554V8.364h.766A1.132,1.132,0,0,0,8.814,7.186,1.119,1.119,0,0,0,7.64,6.014ZM7.491,7.9H6.856V6.481h.638a.666.666,0,0,1,.754.708A.668.668,0,0,1,7.491,7.9Z"
    />
    <path
      className="svg-apple-pay-path5"
      d="M10.119,6.961a.929.929,0,0,0-1.039.8h.5A.486.486,0,0,1,10.1,7.4c.339,0,.53.158.53.447v.2l-.69.042c-.643.04-.992.3-.992.76a.783.783,0,0,0,.873.766.911.911,0,0,0,.816-.455h.013v.428h.512V7.807C11.166,7.293,10.752,6.961,10.119,6.961Zm.515,1.652a.6.6,0,0,1-.661.574c-.294,0-.482-.141-.482-.358s.181-.354.527-.376l.616-.04Z"
    />
    <path
      className="svg-apple-pay-path6"
      d="M12.623,9.1h-.012l-.653-2.108h-.579l.937,2.6-.049.159a.442.442,0,0,1-.468.371,1.6,1.6,0,0,1-.163-.01v.428a1.5,1.5,0,0,0,.215.015c.54,0,.794-.206,1.017-.831l.972-2.729h-.564Z"
    />
  </svg>
)
